import { DefaultTheme } from "styled-components";

export const lightTheme: DefaultTheme = {
  bgColor: "#0081cc",
  textColor: "#fff",
  accentColor: "#edacb1",
};
export const darkTheme: DefaultTheme = {
  bgColor: "#392f31",
  textColor: "#fff",
  accentColor: "#8d192b",
};
